'use strict';

import {isTablet} from '../helpers/responsiveViewport';

var $genbar = {};
var $modalReview = $('#homepage-popup-review-modal');
var $modalBody = $modalReview.find('.modal-body');
var $modalLoader = $modalBody.find('.loader');
var $trialCta = $('.js-post-review');
var $iFrame = document.createElement('iframe');

function resetModal () {
  $modalBody.find('iframe').remove();
  $modalLoader.removeClass('hidden');
}

function initListeners () {
  window.addEventListener('message', e => {
    if (e.data && typeof e.data.indexOf === 'function') {
      if (e.data.indexOf('com.woorank.ready_to_receive') === 0) {
        $trialCta.removeClass('hidden');
        $genbar.remove();
      } else if (e.data.indexOf('com.woorank.height') === 0) {
        var newHeight = parseInt(e.data.split('_').pop(), 10);
        if ('ontouchstart' in document.documentElement && !isTablet()) {
          $iFrame.style.height = newHeight + 'px'; // calculate and update height if Mobile
        }
      }
    }
  }, false);

  $modalReview.on('show.bs.modal', function () {
    window.history.pushState(null, null, '#' + $(this).attr('id'));
  }).on('hide.bs.modal', function () {
    window.history.back();
  });

  $(window).on('popstate', function () {
    if (($modalReview.data('bs.modal') || {}).isShown) {
      $modalReview.modal('hide');
    }
  });
}

function generationBarPopup (url, form) {
  $genbar = form || {};
  initListeners();
  resetModal();
  $modalReview.modal('show');
  $iFrame.src = url;
  $iFrame.style.height = '100%';
  $iFrame.style.width = '100%';
  $iFrame.style.border = 'none';
  $modalBody.append($iFrame);
  $iFrame.onload = (evt) => {
    $modalLoader.addClass('hidden');
  };
}

module.exports = generationBarPopup;
